$(document).ready(function(){
    $("#geography-subnav").hide();
});
